import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isTypingTarget } from '@/lib/keyboard';

// Jump to the header search: Ctrl+K / ⌘K anywhere, or "/" when not typing
// (the Media page keeps "/" for its own search box).
export default function useSearchShortcut(inputRef) {
  const { pathname } = useLocation();
  useEffect(() => {
    const onKey = (e) => {
      const cmdK = (e.metaKey || e.ctrlKey) && !e.altKey && !e.shiftKey && e.key.toLowerCase() === 'k';
      const slash = e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey
        && !isTypingTarget(e.target) && !pathname.startsWith('/media');
      if (!cmdK && !slash) return;
      const el = inputRef.current;
      if (!el || !el.offsetParent) return;
      e.preventDefault();
      el.focus();
      el.select();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [inputRef, pathname]);
}
